<template>
  <span
    class="flex w-fit items-center justify-center text-text4 leading-md text-surface-elevation-1 font-bold px-12 py-2 bg-[#FF5454] border-[#FF5454] rounded-[1.4rem] min-h-28"
  >
    {{ $t('studio.group.home.board_type5_stt_to_be_applied_badge') }}
  </span>
</template>
